import { MavMessage } from "./MavMessage";
import {
    Heartbeat,
    SysStatus,
    Attitude,
    MavMessageParser,
    GpsRawInt,
    ParamValue,
    BatteryStatus,
    VfrHud,
} from "./MavMessageTypes";

export const MavRegistry: Record<MavMessage, MavMessageParser<any>> = {
    [MavMessage.HEARTBEAT]: Heartbeat,
    [MavMessage.SYS_STATUS]: SysStatus,
    [MavMessage.ATTITUDE]: Attitude,
    [MavMessage.GPS_RAW_INT]: GpsRawInt,
    [MavMessage.PARAM_VALUE]: ParamValue,
    [MavMessage.BATTERY_STATUS]: BatteryStatus,
    [MavMessage.VFR_HUD]: VfrHud
};
